import React, { Component } from "react";
import RichTextEditor from 'react-rte';

import {messages} from "../Translations";
import {injectIntl} from "react-intl";

class RteEditor extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: RichTextEditor.createValueFromString(props.input.value, 'html')
        };

        this.onChange = this.onChange.bind(this);
    }

    onChange(value) {
        this.setState({value});
        let preparedValue = value.toString('html').replace(/<a /g, '<a target="_blank" ');
        this.props.input.onChange(preparedValue);
    };

    renderError() {
        if (this.canShowError()) {
            return (
                <div className={'form-control-feedback error-block'}>
                    {this.props.meta.error}
                </div>
            );
        }
        return null;
    }

    canShowError() {
        if (this.props.isUpdate) {
            return this.props.meta.error;
        }
        return this.props.meta.error && this.props.meta.touched;
    }

    applyErrorClass() {
        return this.canShowError() ? 'has-danger' : '';
    }

    render() {
        let label = this.props.label !== undefined ? this.props.label : this.props.intl.formatMessage(messages.description);
        const toolbarConfig = {
            // Optionally specify the groups to display (displayed in the order listed).
            display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS'],
            INLINE_STYLE_BUTTONS: [
                {label: 'Bold', style: 'BOLD'},
                {label: 'Italic', style: 'ITALIC'},
                {label: 'Underline', style: 'UNDERLINE'}
            ],
            BLOCK_TYPE_DROPDOWN: [
                {label: 'Normal', style: 'unstyled'},
                {label: 'Heading Small', style: 'header-four'}
            ],
            BLOCK_TYPE_BUTTONS: [
                {label: 'UL', style: 'unordered-list-item'},
                {label: 'OL', style: 'ordered-list-item'},
                {label: 'BLOCKQUOTE', style:'blockquote'}
            ]
        };
        return (
            <div className={`form-group row ${this.applyErrorClass()}`} id={`div_${this.props.input.name}`}>
                <label className="col-sm-2 col-form-label"><b>{ label }</b></label>
                <div className="col-sm-10">
                    <RichTextEditor
                        value={this.state.value}
                        onChange={this.onChange}
                        toolbarConfig={toolbarConfig}
                        placeholder={this.props.placeholder}
                        stripPastedStyles={true}
                    />
                    {this.renderError()}
                </div>
            </div>
        );
    }
}

export default injectIntl(RteEditor);


// WEBPACK FOOTER //
// ./web/src/components/common/form/RteEditor.jsx